import React from 'react';
import Colors from '../../utils/Colors';
import { ModalLayout } from '../Modal/ModalDialog';
import { Divider, FormLabel, InputGroup } from '../Modal/styled';

type TermsAndConditionsModalProps = {
  additionalInfo: {
    terms_and_conditions: { html: string; text: string };
    privacy_policy: { html: string; text: string };
  };
  termsAndConditionsUrl: string;
};

const TermsAndConditionsModal = ({ additionalInfo, termsAndConditionsUrl }: TermsAndConditionsModalProps) => {
  const { terms_and_conditions, privacy_policy } = additionalInfo || {};
  return (
    <ModalLayout compact>
      {terms_and_conditions?.html && (
        <InputGroup>
          <FormLabel bold>Terms and Conditions:</FormLabel>
          <div
            dangerouslySetInnerHTML={{
              __html: terms_and_conditions?.html
            }}
          />
        </InputGroup>
      )}
      {terms_and_conditions?.html && <Divider />}
      {privacy_policy?.html && (
        <InputGroup>
          <FormLabel bold>Privacy Policy:</FormLabel>
          <div
            dangerouslySetInnerHTML={{
              __html: privacy_policy?.html
            }}
          />
        </InputGroup>
      )}
      <InputGroup>
        {!!termsAndConditionsUrl && (
          <FormLabel>
            <a href={termsAndConditionsUrl} target="_blank" style={{ textDecoration: 'underline', color: Colors?.staticBlack }}>
              Terms and Conditions.
            </a>
          </FormLabel>
        )}
      </InputGroup>
    </ModalLayout>
  );
};

export default TermsAndConditionsModal;
